function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_13",
  "data-name": "Group 13",
  transform: "translate(-23.072 -27.072)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_7",
  "data-name": "Group 7",
  transform: "translate(24 28)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Stroke_1",
  "data-name": "Stroke 1",
  d: "M2.959,0C2.959,6.3,0,8.654,0,12.775,0,17.555,4.487,19,7,19s7-1.445,7-6.225C14,8.654,11.042,6.468,11.042,0Z",
  fill: "none",
  stroke: "#391d4d",
  strokeMiterlimit: 10,
  strokeWidth: 1.855
}), /*#__PURE__*/React.createElement("path", {
  id: "Stroke_3",
  "data-name": "Stroke 3",
  d: "M.5,0V9",
  transform: "translate(7 19)",
  fill: "none",
  stroke: "#391d4d",
  strokeMiterlimit: 10,
  strokeWidth: 2.16
}), /*#__PURE__*/React.createElement("path", {
  id: "Stroke_5",
  "data-name": "Stroke 5",
  d: "M15,.5H0",
  transform: "translate(0 28)",
  fill: "none",
  stroke: "#391d4d",
  strokeMiterlimit: 10,
  strokeWidth: 2.16
})));

var SvgIconWineFortified = function SvgIconWineFortified(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.928,
    height: 30.508,
    viewBox: "0 0 15.928 30.508",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconWineFortified, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-wine-fortified.73f53d64.svg";
export { ForwardRef as ReactComponent };